/**
 * 0.43.94 - HenaketPanel: the Henaket Panel (confirmation / status).
 *
 * A coloured block with a large title and, optionally, a label and a
 * value under it ("Your reference number" / "HDJ2123F"). One component
 * for the published page, the Form preview and the editor canvas.
 *
 *   variant  info | success | warning | error  ("Danger" in the editor);
 *            anything else is info. Warning has black text.
 *   level    the title's heading level, h1..h6 (default h2).
 *   title, label, value: already-resolved strings; an empty label and
 *            value are left out.
 */
import styles from './HenaketPanel.module.css';

export const PANEL_VARIANTS = ['info', 'success', 'warning', 'error'];

export default function HenaketPanel({ variant = 'info', level = 'h2', title = '', label = '', value = '' }) {
  const v = PANEL_VARIANTS.includes(variant) ? variant : 'info';
  const H = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(level) ? level : 'h2';
  const hasPair = (label && String(label).trim()) || (value && String(value).trim());
  return (
    <div className={`${styles.panel} ${styles[v]}`} role={v === 'error' || v === 'warning' ? 'alert' : 'status'}>
      <div className={styles.content}>
        {title && <H className={styles.title}>{title}</H>}
        {hasPair && (
          <div className={styles.pair}>
            {label && <div className={styles.label}>{label}</div>}
            {value && <div className={styles.value}>{value}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
